<template>
  <div class="container">
    <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link tag="li" :to="{ name: 'Home' }">
            <a>Home</a>
          </router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          My Restaurants
        </li>
      </ol>
    </nav>
    <div class="my-restaurant-page">
      <div class="float-end">
        <router-link :to="{ name: 'AddNewRestaurant' }">
          <button class="btn btn-outline-success">
            <faIcons :icon="['fas', 'utensils']" /> Add New Restaurant
          </button>
        </router-link>
      </div>
      <div class="clearfix"></div>
      <div class="main-restaurant-table">
        <!-- View all resturants here -->
        <p v-if="currentRestaurantsArr.length > 0">View My Restaurant(s)</p>
        <div
          v-if="currentRestaurantsArr.length > 0"
          class="row justify-content-around"
        >
          <div
            v-for="i in currentRestaurantsArr"
            :key="i"
            class="col-12 col-sm-6 each-category-list"
          >
            <div>
              <h3>{{ capitalizeFisrtLetterOfEachWord(i.rest_name) }}</h3>
              <hr />
              <p class="mt-2 lightColor">
                <faIcons :icon="['fas', 'map-marker-alt']" />
                {{ capitalizeFisrtLetterOfEachWord(i.rest_address) }}
              </p>
              <p class="lightColor">
                <faIcons :icon="['fas', 'phone-alt']" />
                {{ formatPhoneNumber(i.rest_phone) }}
              </p>
              <hr />
              <div class="mt-2 lightColor" v-if="user.uRole == 'admn'">
                <p>
                  <faIcons :icon="['fas', 'cog']" /> Configure
                  <span class="">
                    <router-link
                      :to="{
                        name: 'ConfigureStripePayment',
                        params: { id: i.id, restId: i.rest_id },
                      }"
                    >
                      Stripe Payment Account
                    </router-link>
                  </span>
                </p>
              </div>
              <div
                class="lightColor"
                :class="user.uRole == 'mngr' ? 'mt-2' : ''"
              >
                <p>
                  <faIcons :icon="['fas', 'cog']" /> Setup
                  <span class="">
                    <router-link
                      :to="{
                        name: 'CurrentRestaurantSettings',
                        params: { id: i.id, restId: i.rest_id },
                      }"
                    >
                      Taxes & Business Availabilty
                    </router-link>
                  </span>
                </p>
              </div>
              <div class="lightColor">
                <p>
                  <faIcons :icon="['fas', 'users']" /> Allow users to
                  <span class="">
                    <router-link
                      :to="{
                        name: 'AccessUsersToOnlineOrders',
                        params: { id: i.id, restId: i.rest_id },
                      }"
                    >
                      access online orders
                    </router-link>
                  </span>
                </p>
              </div>
              <div class="lightColor">
                <p>
                  <faIcons :icon="['fas', 'file-invoice-dollar']" /> Custom
                  restaurant
                  <span class="">
                    <router-link
                      :to="{
                        name: 'CustomRestaurantReceipt',
                        params: { id: i.id, restId: i.rest_id },
                      }"
                    >
                      receipt
                    </router-link>
                  </span>
                </p>
              </div>
              <hr />
              <div class="d-flex justify-content-evenly">
                <span class="text-start" v-if="i.active == 1">
                  <router-link
                    :to="{
                      name: 'CurrentRestaurantMenu',
                      params: { id: i.id, restId: i.rest_id },
                    }"
                  >
                    <button class="btn btn-outline-success">
                      <faIcons :icon="['fas', 'utensils']" /> Menu
                    </button>
                  </router-link>
                </span>
                <span class="text-start" v-if="i.active == 1">
                  <router-link
                    :to="{
                      name: 'UpdateCurrentRestaurant',
                      params: { id: i.id, restId: i.rest_id },
                    }"
                  >
                    <button class="btn btn-outline-secondary">
                      <faIcons :icon="['fas', 'edit']" /> Update
                    </button>
                  </router-link>
                </span>
                <span class="text-end" v-if="i.active == 1">
                  <router-link
                    :to="{
                      name: 'DeactivateRestaurant',
                      params: { id: i.id, restId: i.rest_id },
                    }"
                  >
                    <button class="btn btn-outline-danger">
                      <faIcons :icon="['fas', 'trash']" /> Remove
                    </button>
                  </router-link>
                </span>
                <span class="text-end" v-if="i.active == 0">
                  <router-link
                    :to="{
                      name: 'ActivateRestaurant',
                      params: { id: i.id, restId: i.rest_id },
                    }"
                  >
                    <button class="btn btn-outline-success">
                      <faIcons :icon="['fas', 'trash-restore']" /> Activate
                    </button>
                  </router-link>
                </span>
              </div>
              <hr />
              <div class="clearfix"></div>
              <div class="">
                <p class="mt-2 float-start lightColor">
                  Since {{ new Date(i.added_on).toLocaleDateString() }}
                </p>
                <p class="mt-2 float-end lightColor">
                  Last update {{ new Date(i.last_update).toLocaleDateString() }}
                </p>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
        <div v-else class="d-flex justify-content-evenly">
          <div class="alert alert-dark" role="alert">
            You currently don't have any restaurants added. Add a restaurant now
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewMyRestaurants",
  data() {
    return {
      user: {
        uId: "",
        uUserId: "",
        uName: "",
        uEmail: "",
        uPassword: "",
        uMemberSince: "",
        uAddress: "",
        uPhone: "",
        uRole: "",
        uRoleIs: "",
      },
      currentRestaurantsArr: [],
    };
  },
  mounted() {
    let user = localStorage.getItem("current-user-data");
    let currentRestaurants = localStorage.getItem("current_restaurants_data");
    // console.log(currentRestaurants);
    this.currentRestaurantsArr = JSON.parse(currentRestaurants);
    if (user != null) {
      this.user.uId = JSON.parse(user).id;
      this.user.uUserId = JSON.parse(user).user_id;
      this.user.uName = JSON.parse(user).name;
      this.user.uEmail = JSON.parse(user).email;
      this.user.uPassword = JSON.parse(user).password;
      this.user.uMemberSince = JSON.parse(user).member_since;
      this.user.uAddress = JSON.parse(user).full_address;
      this.user.uPhone = JSON.parse(user).phone_number;
      this.user.uRole = JSON.parse(user).role;
      //if role for Admin or Manager, redirect
      if (
        this.user.uRole !== "admn" &&
        this.user.uRole !== "mngr"
      ) {
        console.log("Login is not a manager/admin user");
        this.$router.push({ name: "Login" });
      }
    } else {
      console.log("Login is not authorized user");
      this.$router.push({ name: "Login" });
    }
  },
  methods: {
    capitalizeFisrtLetterOfEachWord(text) {
      return text
        .toLowerCase()
        .split(" ")
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(" ");
    },
    addNewRestaurant() {
      this.$router.push({ name: "AddNewRestaurant" });
    },
    formatPhoneNumber(number) {
      //remove . + -  from any number
      let cleaned = ("" + number).replace(/\D/g, "");
      let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return "(" + match[1] + ") " + match[2] + "-" + match[3];
      }
      return null;
    },
  },
};
</script>
<style lang="scss" scoped>
$navColor: #3f51b6;
a {
  text-decoration: none;
  color: $navColor;
  font-weight: bold;
}
.each-category-list {
  padding: 15px;
  border-radius: 5px;
  box-shadow: 2px 2px 4px 0px #525a5a;
  margin: 8px;
}
.addressDisplay {
  white-space: pre-wrap;
}
.lightColor {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
</style>
